// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__VgDpZ","signatureButtonsRight":"ModalSign_signatureButtonsRight__vl-Wx"};